import {
  AlarmLevel,
  AlarmLevelColorDisplay,
  AlarmLevelDisplay,
  AlarmStatus,
  AlarmStatusDisplay,
  AlarmType,
  AlarmTypeDisplay,
} from '@/shared/types';
import { EllipsisSpan, Tag } from '@maxtropy/components';

export const columns = [
  {
    title: '规则编码/名称',
    dataIndex: 'ruleName',
    fixed: 'left' as const,
    width: 208,
    ellipsis: { showTitle: true },
    render: (v: string, record: any) => (
      <EllipsisSpan value={(record?.ruleName ?? '') + '-' + (record?.ruleCode ?? '')} />
    ),
  },
  {
    title: '报警等级',
    dataIndex: 'alarmType',
    width: 150,
    ellipsis: { showTitle: true },
    render: (v: AlarmLevel) => (
      <EllipsisSpan
        value={
          <Tag border="solid" color={AlarmLevelColorDisplay[v]}>
            {AlarmLevelDisplay[v]}
          </Tag>
        }
      />
    ),
  },
  {
    title: '所属规则组',
    width: 180,
    dataIndex: 'ruleGroupName',
    ellipsis: { showTitle: true },
    render: (v: string) => <EllipsisSpan value={v} />,
  },
];

export const ruleModalColumns = [
  {
    title: '规则名称',
    dataIndex: 'name',
    ellipsis: { showTitle: true },
    render: (v: string) => <EllipsisSpan value={v} />,
  },
  {
    title: '规则编码',
    dataIndex: 'code',
    ellipsis: { showTitle: true },
    render: (v: string) => <EllipsisSpan value={v} />,
  },
  {
    title: '所属类目',
    dataIndex: 'deviceTypeName',
    ellipsis: { showTitle: true },
    render: (v: string) => <EllipsisSpan value={v} />,
  },
  {
    title: '规则状态',
    dataIndex: 'status',
    ellipsis: { showTitle: true },
    render: (v: AlarmStatus) => <EllipsisSpan value={AlarmStatusDisplay[v]} />,
  },
  {
    title: '报警等级',
    dataIndex: 'alarmType',
    ellipsis: { showTitle: true },
    render: (v: AlarmLevel) => <EllipsisSpan value={AlarmLevelDisplay[v]} />,
  },
  {
    title: '所属规则组',
    dataIndex: 'ruleGroupName',
    ellipsis: { showTitle: true },
    render: (v: string) => <EllipsisSpan value={v} />,
  },
];

export const deviceColumns = [
  {
    title: '设备名称',
    dataIndex: 'name',
    ellipsis: { showTitle: true },
    render: (v: string) => <EllipsisSpan value={v} />,
  },
  {
    title: '设备编码',
    dataIndex: 'code',
    ellipsis: { showTitle: true },
    render: (v: string) => <EllipsisSpan value={v} />,
  },
  {
    title: '所属类目',
    dataIndex: 'deviceType',
    ellipsis: { showTitle: true },
    render: (v: string) => <EllipsisSpan value={v} />,
  },
  {
    title: '运营单元',
    dataIndex: 'ouName',
    ellipsis: { showTitle: true },
    render: (v: string) => <EllipsisSpan value={v} />,
  },
];
